import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
    return (
        <div className='footer'>
            <p>© 2025 Home Salon | <Link to="https://www.mrhussain.in/portfolio/" target="_blank">Aesthetic Retail Pvt. Ltd.</Link></p>
        </div>
    )
}
